import { baseApi } from "@/core/api/baseApi";
import type { ListSessionsResponseDTO } from "../../domain/dto/SessionDTO";
import type { DeviceSession } from "../../domain/entities/DeviceSession";
import { mapSessionsResponse } from "./mapper";

export const sessionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET ACTIVE SESSIONS (LOGGED-IN DEVICES)
    getSessions: builder.query<DeviceSession[], void>({
      query: () => ({ url: "/auth/sessions" }),
      transformResponse: (response: ListSessionsResponseDTO) =>
        mapSessionsResponse(response),
      providesTags: ["Sessions"],
    }),

    // REVOKE A SINGLE SESSION
    revokeSession: builder.mutation<void, string>({
      query: (sessionId) => ({
        url: `/auth/sessions/${sessionId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Sessions"],
    }),

    // REVOKE ALL SESSIONS (OPTIONALLY KEEPING THE CURRENT ONE)
    revokeAllSessions: builder.mutation<void, { keepCurrent: boolean }>({
      query: ({ keepCurrent }) => ({
        url: "/auth/sessions",
        method: "DELETE",
        body: { keep_current: keepCurrent },
      }),
      invalidatesTags: ["Sessions"],
    }),
  }),
});

export const {
  useGetSessionsQuery,
  useRevokeSessionMutation,
  useRevokeAllSessionsMutation,
} = sessionsApi;
